module.exports = "/legacy/6e3aa8920f98187f50bab6a79d1b1aff.png";